/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* skeleton for food types, menu items, promotion tier */
import React from 'react';
import { ShimmerText, ShimmerButton, ShimmerTable } from 'react-shimmer-effects';

function OutstandingInvoiceSkeleton() {
    return (

        <div className="w-full table-auto relative pt-[25px]">
            <ShimmerTable row={10} col={9} />
        </div>
    );
}

export default OutstandingInvoiceSkeleton;
